export const filtersModule = angular.module('channel.filters', []);
